import styled from 'styled-components';

import {
    getPurpurBorder,
    getPurpurColor,
    getPurpurShadow,
    purpurMedia,
} from '@telialt/common-theme/src/purpurSelectors';

type DropdownProps = {
    $isActive: boolean;
    $navBarHeight: number;
};

export const DropdownOverlay = styled.div`
    display: none;

    ${purpurMedia('lg')`
        display: block;
        position: absolute;
        width: 100%;
        height: 100dvh;
        top: 100%;
        bottom: 0;
        right: 0;
        left: 50%;
        transform: translateX(-50%);
        margin: 0;
        padding: 0;
        background-color: transparent;
        z-index: 2000;
    `};
`;

export const StyledDropdown = styled.div<DropdownProps>`
    display: ${({ $isActive }) => ($isActive ? 'block' : 'none')};
    position: fixed;
    width: 100%;
    background-color: ${getPurpurColor('functionalWhite')};
    z-index: 2001;
    top: ${({ $navBarHeight }) => (typeof $navBarHeight === 'number' ? `${$navBarHeight}px` : '0')};
    bottom: 0;
    left: 0;
    right: 0;
    overflow: auto;
    text-align: left;

    ${purpurMedia('lg')`
        position: absolute;
        max-width: 73.25rem;
        width: 100%;
        z-index: 2001;
        border-radius: 0 0 ${getPurpurBorder('radiusMd')} ${getPurpurBorder('radiusMd')};
        box-shadow: ${getPurpurShadow('md')}, inset 0px 11px 8px -10px ${getPurpurColor('transparentBlack100')};
        bottom: auto;
        top: 100%;
        left: 50%;
        right: auto;
        transform: translate(-50%);
        margin-top: 0;
    `}

    ${({ $navBarHeight }) =>
        purpurMedia('lg')`
            max-height: ${`calc(100vh - ${$navBarHeight}px)`};
        `};
`;
